import React from "react";
import { Col, Row } from "react-bootstrap";
import { SiLeetcode, SiCodechef, SiCodeforces } from "react-icons/si";

const cpProfiles = [
  { icon: <SiLeetcode />, name: "LeetCode", link: "https://www.leetcode.com/tarun_talan" },
  { icon: <SiCodechef />, name: "CodeChef", link: "https://www.codechef.com/users/taruntalan" },
  { icon: <SiCodeforces />, name: "Codeforces", link: "https://codeforces.com/profile/taruntalan" }
];

function Cpstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {cpProfiles.map((profile, index) => (
        <Col xs={4} sm={3} md={2} key={index} className="d-flex justify-content-center mb-4">
          <a
            href={profile.link}
            target="_blank"
            rel="noopener noreferrer"
            className="tech-icons"
            style={{
              color: "inherit",
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
            }}
          >
            {profile.icon}
            <span className="tech-icons-text">{profile.name}</span>
          </a>
        </Col>
      ))}
    </Row>
  );
}

export default Cpstack;
